import { SET_PLUGIN_MANIFEST } from '../constants/actions';

export default function (pluginId, version, manifest) {
  return {
    type: SET_PLUGIN_MANIFEST,
    pluginId,
    version,
    manifest,
  };
}
